import { render, staticRenderFns } from "./special-goods-item.vue?vue&type=template&id=359cefd0&scoped=true"
import script from "./special-goods-item.vue?vue&type=script&lang=ts"
export * from "./special-goods-item.vue?vue&type=script&lang=ts"
import style0 from "./special-goods-item.vue?vue&type=style&index=0&id=359cefd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359cefd0",
  null
  
)

export default component.exports